import MockupOffer from './MockupOffer'

export default MockupOffer
